// Lets a trigger button anywhere open the single globally mounted palette
// (either implementation) without sharing store/state across mounts.
const OPEN_EVENT = 'pigello:global-search-open';

interface OpenGlobalSearchDetail {
  readonly page?: 'search' | 'filter';
}

export function openGlobalSearch(detail?: OpenGlobalSearchDetail) {
  window.dispatchEvent(new CustomEvent(OPEN_EVENT, { detail }));
}

export function onGlobalSearchOpen(
  callback: (detail?: OpenGlobalSearchDetail) => void
) {
  const handler = (e: Event) =>
    callback((e as CustomEvent<OpenGlobalSearchDetail | undefined>).detail);
  window.addEventListener(OPEN_EVENT, handler);
  return () => window.removeEventListener(OPEN_EVENT, handler);
}
